import { useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, type = 'warning' }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const handleEscape = (e) => {
        if (e?.key === 'Escape') onClose();
      };
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleEscape);
        document.body.style.overflow = '';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const iconConfig = {
    warning: { name: 'AlertTriangle', color: 'var(--color-warning)' },
    danger: { name: 'AlertCircle', color: 'var(--color-destructive)' },
    info: { name: 'Info', color: 'var(--color-primary)' }
  };

  const config = iconConfig?.[type] || iconConfig?.warning;

  return (
    <div 
      className="fixed inset-0 z-[1000] bg-background/80 flex items-center justify-center p-4"
      onClick={(e) => e?.target === e?.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div 
        ref={modalRef}
        className="bg-card rounded-2xl shadow-soft-xl max-w-md w-full overflow-hidden"
      >
        <div className="p-6 md:p-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: `${config?.color}20` }}>
              <Icon name={config?.name} size={24} color={config?.color} />
            </div>
            <div className="flex-1">
              <h3 id="modal-title" className="text-xl md:text-2xl font-semibold text-foreground mb-2">
                {title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground">
                {message}
              </p>
            </div>
          </div>

          <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
            <Button
              variant="outline"
              onClick={onClose}
              className="w-full sm:w-auto"
            >
              Cancel
            </Button>
            <Button
              variant={type === 'danger' ? 'destructive' : 'default'}
              onClick={onConfirm}
              className="w-full sm:w-auto"
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;